import { useState, useEffect } from 'react';

export const useAdminAuth = () => {
  const [authed, setAuthed] = useState(!!localStorage.getItem('lg_admin_token'));
  useEffect(() => {
    const h = () => setAuthed(!!localStorage.getItem('lg_admin_token'));
    window.addEventListener('storage', h);
    window.addEventListener('lg_auth_change', h);
    return () => { window.removeEventListener('storage', h); window.removeEventListener('lg_auth_change', h); };
  }, []);
  return authed;
};
